import styles from "./settingsPagesContainer.module.css";
import TextWrapper from "../textWrapper/TextWrapper";
import DisplayContainer from "../displayContainer/DisplayContainer";

const SettingsPagesContainer = ({
  children,
  title,
  fullWidth,
  fullHeight,
  displayContainerClassName = "",
}) => {
  return (
    <div className={`${styles.container} ${fullHeight ? styles.fullHeightContainer : ""}`}>
      <TextWrapper textStyle="textTitle">{title}</TextWrapper>
      <div
        className={`${styles.displayContainerWrapper} ${fullWidth ? styles.fullWidth : ""} ${
          fullHeight ? styles.fullHeightWrapper : ""
        }`}
      >
        <DisplayContainer className={displayContainerClassName}>
          {children}
        </DisplayContainer>
      </div>
    </div>
  );
};

export default SettingsPagesContainer;
